import React from 'react';

import NextLink from '../NextLink';

import { CategoryPillsPropsTypes } from './CategoryPills.types';

const CategoryPills: React.FC<CategoryPillsPropsTypes> = ({ className, post, locale }) => {
  return (
    <div className={`relative ${className}`}>
      <div
        className='absolute top-[0] right-[-0.1rem] h-[2.5rem] w-[5rem] bg-[red]'
        style={{
          background: 'linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1))',
        }}
      />
      <div className='no-scrollbar flex flex-nowrap gap-[0.8rem] overflow-x-auto overflow-y-hidden pr-[3rem]'>
        {post?.productsCollection?.items?.map((product: any) => (
          <NextLink
            className='text-body-copy--dark h-[2.5rem] shrink-0 rounded-full bg-[#F9F9F9] px-[1rem] font-light'
            key={product?.sys?.id}
            href={`/news?product=${product.slug}`}
            locale={locale}
          >
            {product?.name}
          </NextLink>
        ))}
        {post?.topicsCollection?.items?.map((topic: any) => (
          <NextLink
            locale={locale}
            className='text-body-copy--dark h-[2.5rem] shrink-0 rounded-full bg-[#F9F9F9] px-[1rem] font-light'
            key={topic?.sys?.id}
            href={`/news?topic=${topic.slug}`}
          >
            {topic?.title}
          </NextLink>
        ))}
      </div>
    </div>
  );
};

export default CategoryPills;
